<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <l-map
                    v-if="loaded"
                    :zoom="zoom"
                    :center="center"
                    ref="map"
                    style="height: 418px"
                >
                    <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                    ></l-tile-layer>
                    <l-control class="map-custom-control">
                        <dashboard-filters
                            key="asset"
                            title="Assets"
                            :filters="['assetType', 'assetSearch']"
                            :asset-types="assetTypesOptions"
                            @asset-search="assetSearch = $event"
                            @select-asset-type="assetTypeId = $event"
                        />
                    </l-control>
                    <l-circle-marker
                        v-for="(asset, index) in formattedAssets"
                        :key="index"
                        :lat-lng="formattedAssets[index].latlng"
                        :radius="asset.radius"
                        :color="asset.next_service_date | formatColor"
                        :fill-color="asset.next_service_date | formatColor"
                        style="z-index: 5000 !important"
                    >
                        <l-popup :autoClose="false">
                            <span class="popup_header">{{ asset.name }}</span
                            ><br />
                            <span class="popup_label">Customer:</span
                            >{{ asset.customer_name }}<br />
                            <span class="popup_label">Next Service:</span
                            >{{ asset.next_service_date }}<br />
                            <span class="popup_label">Type:</span
                            >{{ asset.type_name }}<br />
                            <span class="popup_label">Serial Number:</span
                            >{{ asset.serial_no }}<br />
                            <a :href="asset.id | formatPath">View Details</a>
                        </l-popup>
                    </l-circle-marker>
                    <l-geo-json :geojson="geojson"></l-geo-json>
                </l-map>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import DashboardFilters from '@/views/Dashboard/DashboardFilters'
import {
    LMap,
    LTileLayer,
    LCircleMarker,
    LPopup,
    LGeoJson,
    LControl,
} from 'vue2-leaflet'
import L from 'leaflet'
import jamaica_parishes_geojson from '../../exports/geoserver-GetFeature.json'

const defaultLocation = L.latLng(18, -77.2)

export default {
    name: 'assets-map',
    components: {
        LMap,
        LTileLayer,
        LCircleMarker,
        LPopup,
        LGeoJson,
        LControl,
        DashboardFilters,
    },
    props: {
        assets: {
            type: Array,
            default: () => [],
        },
        assetTypes: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => defaultLocation,
        },
        loaded: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            assetTypeId: null,
            assetSearch: '',
            geojson: jamaica_parishes_geojson,
            zoom: 8,
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },

    filters: {
        formatPath(id) {
            return `/#/admin/assets/${id}`
        },
        formatColor(next_service_date) {
            const dateDiff = xdate =>
                (new Date(xdate).getTime() - Date.now()) /
                (1000 * 60 * 60 * 24 * 30)
            const ddiff = dateDiff(next_service_date)
            if (ddiff > 1) {
                return 'green'
            } else if (ddiff > 0) {
                return 'yellow'
            } else {
                return 'red'
            }
        },
    },
    computed: {
        assetTypesOptions() {
            return this.assetTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        formattedAssets() {
            const { assetSearch, assetTypeId } = this
            const assets = this.getAssets(assetSearch, assetTypeId)

            return assets.map(_asset => {
                _asset.radius = 8

                const { latitude, longitude } = this.setCoordinate(_asset)

                _asset.latlng = new L.latLng(latitude, longitude)

                return _asset
            })
        },
        center() {
            const count = this.formattedAssets.length
            if (count === 0) return defaultLocation
            const s = this.formattedAssets.reduce(
                (sum, asset) => {
                    const { latitude, longitude } = this.setCoordinate(asset)
                    sum.latitude += latitude
                    sum.longitude += longitude
                    return sum
                },
                {
                    latitude: 0,
                    longitude: 0,
                }
            )
            let latitude = 0,
                longitude = 0
            if (count > 0) {
                latitude = s.latitude / count
                longitude = s.longitude / count
            }
            return new L.latLng(latitude, longitude)
        },
    },
    watch: {
        loaded: function (val) {
            if (val) {
                const $this = this
                this.$nextTick(() => {
                    const map = $this.$refs.map.mapObject
                    map.addControl(new L.Control.Fullscreen())
                })
            }
        },
    },

    mounted() {
        console.log('assets-mounted', this.assets)
    },
    methods: {
        setCoordinate({ longitude, latitude }) {
            longitude = parseFloat(longitude) || -77.2
            latitude = parseFloat(latitude) || 18
            return { longitude, latitude }
        },
        getAssets(assetSearch, type_id) {
            if (!assetSearch && !type_id) return this.assets
            const x_search = (assetSearch || '').trim().toLowerCase()
            return this.assets.filter(
                x =>
                    (!x_search ||
                        x.customer_name.toLowerCase().indexOf(x_search) >= 0 ||
                        x.name.toLowerCase().indexOf(x_search) >= 0) &&
                    (!type_id || type_id === x.type_id)
            )
        },
    },
}
</script>

<style>
.autocomplete input {
    border-radius: 0;
}
#map.fullscreen {
    z-index: 9999;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

#map.leaflet-bottom {
    z-index: 1 !important;
}

#map {
    height: 418px;
    z-index: 0 !important;
}

#map.leaflet-control {
    z-index: 0 !important;
}

.map-custom-control {
    background: #fff;
    padding: 0 0.5em;
    border: 1px solid #aaa;
    border-radius: 0.1em;
    z-index: 1 !important;
}
dl {
    display: grid;
    grid-template-columns: max-content auto;
}

dt {
    grid-column-start: 1;
}

dd {
    grid-column-start: 2;
}

.popup_header {
    text-decoration: underline;
    font-weight: bold;
}

.popup_label {
    font-weight: bold;
}
</style>